
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Msfabricationshade() {



  const cardData =
  {
    keyword: ' MS Fabrication Shade Installation ',
    heading: 'Anjali Enterprises: MS Fabrication Shade Installation ',
    headingDescription: 'Anjali Enterprises offers professional MS (Mild Steel) fabrication shade installation services, delivering durable and reliable shading solutions for a variety of residential and commercial applications. Our steel shades are designed to provide protection from the elements while enhancing the aesthetics of your outdoor and indoor spaces. Whether you need industrial steel shades, fabricated roof shades, or outdoor steel shade installations, we provide high-quality, custom solutions tailored to your specific needs.',

    "topPlaces": [
        {
          "title": "Industrial Steel Shades",
          "description": "We specialize in industrial steel shades designed to provide maximum protection and durability. Ideal for factories, warehouses, and industrial buildings, our steel shades are engineered to withstand harsh conditions while offering reliable shelter and shade."
        },
        {
          "title": "MS Shade Work",
          "description": "Our MS shade work involves the careful design and fabrication of steel structures to provide shading solutions that are both functional and aesthetically pleasing. From residential gardens to commercial spaces, we offer tailored MS shading solutions to meet your unique needs."
        },
        {
          "title": "Fabricated Steel Roof Shades",
          "description": "Anjali Enterprises excels in the installation of fabricated steel roof shades, designed to offer long-lasting protection from the sun and rain. Our steel roof shades are ideal for parking spaces, open areas, and any outdoor space requiring protection from the elements."
        },
        {
          "title": "MS Fabrication Work for Commercial Use",
          "description": "We provide comprehensive MS fabrication work for commercial use, including steel shades for storefronts, outdoor seating areas, and more. Our steel fabrication services ensure that your commercial space is not only functional but also visually appealing."
        },
        {
          "title": "Steel Shed Construction",
          "description": "Our steel shed construction services are designed to offer durable, cost-effective, and high-performance shed solutions for a variety of applications. Whether you need a shed for storage, parking, or any other purpose, we provide steel structures that stand the test of time."
        },
        {
          "title": "Outdoor Steel Shade Installation",
          "description": "Anjali Enterprises provides expert outdoor steel shade installation for homes and businesses. Our steel shades are ideal for creating shaded areas in gardens, patios, walkways, and parking spaces, providing comfort and protection from the sun and rain."
        },
        {
          "title": "MS Shading Solutions for Offices and Homes",
          "description": "Our MS shading solutions are perfect for both office and home spaces, offering a practical and stylish way to protect your interior and exterior areas from harsh weather conditions. We provide customized MS shade designs to suit your specific requirements."
        },
        {
          "title": "Fabricated Shade Panels in Pune",
          "description": "We offer fabricated shade panels in Pune, crafted from high-quality materials for lasting durability. Our shade panels are ideal for use in commercial buildings, residential complexes, and outdoor spaces, providing both shelter and style."
        },
        {
          "title": "MS Shade for Outdoor Spaces",
          "description": "Our MS shades for outdoor spaces are designed to provide both functional protection and visual appeal. Perfect for gardens, patios, balconies, and terraces, these steel shades ensure that your outdoor spaces remain comfortable and protected."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality MS (Mild Steel) fabrication shade installation services. We specialize in providing durable and custom-designed MS shades for various residential and commercial applications, offering protection from the sun and adding a stylish look to your space. Get in touch for expert installation and professional service. Serving Pune with top-notch MS fabrication shade solutions tailored to your needs."
        }
      ],
      "tableData": [
        ["- Industrial Steel Shades", "- MS Shade Work"],
        ["- Fabricated Steel Roof Shades", "- MS Fabrication Work for Commercial Use"],
        ["- Steel Shed Construction", "- Outdoor Steel Shade Installation"],
        ["- MS Shading Solutions for Offices and Homes", "- Fabricated Shade Panels in Pune"],
        ["- MS Shade for Outdoor Spaces", "- Anjali Enterprises Contact Number"],
        ["", ""]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Durability and Strength",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in MS (Mild Steel) fabrication shades that are built to last. These shades provide excellent protection against the elements while offering durability, strength, and long-term performance. They are perfect for both residential and commercial spaces."
  },
  {
    "WhyChooseheading": "Customizable Designs",
    "WhyChoosedescription": "Our MS fabrication shades can be customized to suit your specific requirements. Whether you need a small canopy for your patio, a large shade for your outdoor space, or a durable shade structure for your business, we can design and fabricate the perfect solution."
  },
  {
    "WhyChooseheading": "Weather-Resistant",
    "WhyChoosedescription": "Our MS fabrication shades are made from high-quality materials that are resistant to corrosion and weather damage. With proper treatment and coating, these shades can withstand harsh weather conditions, such as heavy rain, strong winds, and intense sun exposure."
  },
  {
    "WhyChooseheading": "Affordable and High-Quality",
    "WhyChoosedescription": "We offer competitive pricing for MS fabrication shades without compromising on quality. Our shades are built from premium-grade mild steel and are designed to provide maximum protection and value for money."
  },
  {
    "WhyChooseheading": "Versatile Applications",
    "WhyChoosedescription": "MS fabrication shades are versatile and can be used in a variety of applications, including parking shades, terrace coverings, outdoor seating areas, walkways, and more. Whether you are looking for a functional solution or a decorative element for your property, our shades meet all needs."
  },
  {
    "WhyChooseheading": "Professional Installation",
    "WhyChoosedescription": "Our experienced team ensures that the MS fabrication shades are carefully fabricated and installed to the highest standards. We handle every step of the process—from design and fabrication to installation—ensuring a perfect fit for your space."
  },
  {
    "WhyChooseheading": "Energy Efficiency",
    "WhyChoosedescription": "Installing MS fabrication shades can help keep your outdoor spaces cooler and more comfortable by providing shelter from the sun. This can reduce the temperature around your home or business, creating a more energy-efficient environment."
  },
  {
    "WhyChooseheading": "Easy Maintenance",
    "WhyChoosedescription": "MS fabrication shades require minimal maintenance. They are designed to be durable and long-lasting, but occasional cleaning is recommended to keep them looking good and functioning properly."
  },
  {
    "WhyChooseheading": "Stylish and Modern Designs",
    "WhyChoosedescription": "Our MS shades are not only functional but also aesthetically pleasing. We offer various designs, from simple and classic to modern and intricate, ensuring that your shade complements the overall style of your property."
  }
]



  }

  const faqData = [
    {
      question: "What is an MS fabrication shade?",
      answer: "An MS (Mild Steel) fabrication shade is a shade structure made from mild steel, providing protection from weather elements like sun, rain, and wind. These shades are highly durable and can be customized for various uses."
    },
    {
      question: "Can MS fabrication shades be customized?",
      answer: "Yes, we offer fully customizable MS fabrication shades to meet your specific needs. From the size and shape to the design and finish, we tailor our solutions to your requirements."
    },
    {
      question: "Are MS fabrication shades resistant to rust?",
      answer: "Yes, our MS fabrication shades are treated with anti-corrosive coatings to ensure resistance to rust and corrosion, even in harsh weather conditions."
    },
    {
      question: "What types of applications can MS fabrication shades be used for?",
      answer: "MS fabrication shades are versatile and can be used for a variety of applications, including parking shades, terrace coverings, awnings, outdoor seating areas, walkways, and more."
    },
    {
      question: "How long will MS fabrication shades last?",
      answer: "With proper care and maintenance, MS fabrication shades can last for many years. They are made from durable materials and are designed to withstand various weather conditions."
    },
    {
      question: "How do I maintain my MS fabrication shade?",
      answer: "MS fabrication shades require minimal maintenance. Regular cleaning to remove dirt and debris will help keep them looking good. We also recommend periodic inspections to ensure they remain in excellent condition."
    },
    {
      question: "Can MS fabrication shades be installed on existing structures?",
      answer: "Yes, MS fabrication shades can be installed on existing structures, such as balconies, terraces, and open spaces. We customize the design to fit seamlessly with your property’s layout."
    },
    {
      question: "How much does MS fabrication shade installation cost?",
      answer: "The cost of MS fabrication shade installation depends on the size, design, and complexity of the project. Contact us for a free consultation and customized quote."
    },
    {
      question: "Are MS fabrication shades eco-friendly?",
      answer: "Yes, MS fabrication shades are eco-friendly, as they are made from durable materials that last longer, reducing the need for replacements. Additionally, they help with energy efficiency by reducing heat in outdoor areas."
    },
    {
      question: "Why should I choose Anjali Enterprises for MS fabrication shade installation?",
      answer: "Anjali Enterprises offers high-quality, durable, and aesthetically pleasing MS fabrication shades. Our professional team ensures precision in design, fabrication, and installation, providing excellent value for money and long-lasting protection."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Deepak Mehta",
      text: "We installed MS fabrication shades on our terrace, and we couldn’t be happier with the result. The shades provide excellent protection from the sun and look stylish. The installation was quick and professional, and the team was highly skilled."
    },
    {
      name: "Mrs. Rina Patel",
      text: "Anjali Enterprises installed MS fabrication shades for our office parking area. The shades are strong, durable, and have provided much-needed relief from the sun. Their team handled the entire process smoothly and efficiently."
    }
  ];
  


  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title>Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Shade Installation Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers MS fabrication shade installation services in Pune, providing industrial steel shades, MS roof shades, outdoor steel shade installation, and custom shading solutions for offices and homes. Call +91 8793220265 for MS shade solutions." />
  <meta name="keywords" content="MS Fabrication Shade Installation, Industrial Steel Shades, MS Shade Work, Fabricated Steel Roof Shades, MS Fabrication Work for Commercial Use, Steel Shed Construction, Outdoor Steel Shade Installation, MS Shading Solutions for Offices and Homes, Fabricated Shade Panels Pune, MS Shade for Outdoor Spaces" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Shade Installation Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers MS fabrication shade installation services in Pune, providing industrial steel shades, MS roof shades, outdoor steel shade installation, and custom shading solutions for offices and homes. Call +91 8793220265 for MS shade solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/ms-fabrication-shade-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/ms-fabrication-shade-installation" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers MS fabrication shade installation services in Pune, providing industrial steel shades, MS roof shades, outdoor steel shade installation, and custom shading solutions for offices and homes. Call +91 8793220265 for MS shade solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/ms-fabrication-shade-installation",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/ms-fabrication-shade-service.jpg",
        "priceRange": "₹5000 - ₹25000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/ms-fabrication-shade-installation",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "30"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Manoj S"
            },
            "datePublished": "2024-05-05",
            "reviewBody": "We had MS fabricated shades installed in our outdoor spaces. The quality of work was excellent, and the installation was done promptly. Highly satisfied with Anjali Enterprises' service!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Pooja J"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "Anjali Enterprises did an outstanding job with the MS fabrication shade for our office. The steel shade work was exactly what we needed. Great service and professional team!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/ms-fabrication-shade-installation"
        },
        "keywords": "MS Fabrication Shade Installation, Industrial Steel Shades, MS Shade Work, Fabricated Steel Roof Shades, MS Fabrication Work for Commercial Use, Steel Shed Construction, Outdoor Steel Shade Installation, MS Shading Solutions for Offices and Homes, Fabricated Shade Panels Pune, MS Shade for Outdoor Spaces"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/11.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Msfabricationshade;